import { render, staticRenderFns } from "./WeetPlayer.vue?vue&type=template&id=70b56e7d&scoped=true"
import script from "./WeetPlayer.vue?vue&type=script&lang=ts"
export * from "./WeetPlayer.vue?vue&type=script&lang=ts"
import style0 from "./WeetPlayer.vue?vue&type=style&index=0&id=70b56e7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b56e7d",
  null
  
)

export default component.exports